import React from "react"
import Style from "@/components/ProductDetail/v3/SuperSkuOption/index.module.scss"

const SuperSkuOptionButton = props => {
  const { sku, slug, optionLabel, isActive, disabled, onClick } = props || {}

  const selectedClass = isActive
    ? Style.activeBttn
    : disabled
    ? Style.disabledBttn
    : ""

  const classButton = `${Style.superSkuOptionButton} ${selectedClass} `

  return (
    <button
      disabled={disabled}
      className={classButton}
      onClick={() => onClick({ optionLabel, sku, slug })}
    >
      {optionLabel}
    </button>
  )
}

export default SuperSkuOptionButton
